import Swiper, { Controller, EffectFade, FreeMode, Lazy, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initialize() {
    let swiperThumbs;

    if ($('.slider-procampo-video .swiper-procampo-video-thumbs').length > 0) {
        swiperThumbs = new Swiper('.slider-procampo-video .swiper-procampo-video-thumbs', {
            modules: [Navigation, Pagination, Lazy, FreeMode, Thumbs, Scrollbar],

            watchSlidesProgress: true,

            direction: 'horizontal',
            slidesPerView: 3,
            centerInsufficientSlides: true,

            loop: true,

            breakpoints: {
                0: {
                    spaceBetween: 8,
                    slidesPerView: 'auto',
                },
                768: {
                    spaceBetween: 18,
                    slidesPerView: 'auto',
                    centerInsufficientSlides: true,
                },
            },
        });
    }

    const swiperOptions = {
        modules: [Controller, Navigation, Pagination, Lazy, EffectFade, Thumbs],

        slidesPerView: 1,

        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 1,
        },
    };

    const swiperContent = new Swiper('.slider-procampo-video .swiper-procampo-video-content', {
        modules: [Controller, Pagination, Lazy, EffectFade],

        slidesPerView: 1,

        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        allowTouchMove: false,
    });

    const swiperVideo = new Swiper('.slider-procampo-video .swiper-procampo-video-player', {
        ...swiperOptions,

        thumbs: {
            swiper: swiperThumbs,
        },

        controller: {
            control: swiperContent,
        },

        navigation: {
            prevEl: '.slider-procampo-video .btn-prev',
            nextEl: '.slider-procampo-video .btn-next',
        },
    });
}

initialize();
